import { EngineStoreInitialData, useEngineStore } from "@/stores/EngineStore/EngineStore.ts";

export const resetEngineStoreHelper = (skipDateRangeReset: boolean) => {
  const tomorrowDate = new Date(+new Date() + 86400000);
  const dayAfterTomorrowDate = new Date(+tomorrowDate + 86400000);

  const initialState: Omit<EngineStoreInitialData, "page" | "calculatedCartData"> = {
    rootAttributes: {
      hide_language_picker: undefined,
      api_url: undefined,
    },
    defaultDateRange: skipDateRangeReset
      ? useEngineStore.getState().defaultDateRange
      : [tomorrowDate, dayAfterTomorrowDate],
    defaultAdults: 2,
    defaultRateGroups: [],
    cartAccommodationItems: [],
    reservationHolderData: null,
    paymentData: null,
    paymentResult: null,
    acceptedGDPR: false,
    isGDPRHighlighted: false,
    accommodationTypeId: undefined,
    isReserved: false,
    reservationOfferId: undefined,
  };

  return initialState;
};
